<template>
  <div class="container">
   
  </div>
</template>

<script>
export default {
 
  data() {
    return {
      
    };
  },

  mounted() {
    
  },
  methods: {
    init() {
      
    },
    //获取列表
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/user/deviceInvestPlan/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          admin_id: this.admin_id,
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>